import { CalendarEvent, EEventStatus } from '../types/events';

// Global calendar event manager
class CalendarEventManager {
  private static instance: CalendarEventManager;
  private updateEventCallback: ((eventId: string, updates: Partial<CalendarEvent>) => void) | null = null;
  private deleteEventCallback: ((eventId: string) => void) | null = null;
  private addEventCallback: ((event: CalendarEvent) => void) | null = null;

  // Private constructor to enforce singleton pattern
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  private constructor() {}

  static getInstance(): CalendarEventManager {
    if (!CalendarEventManager.instance) {
      CalendarEventManager.instance = new CalendarEventManager();
    }
    return CalendarEventManager.instance;
  }

  // Register callbacks from calendar context
  registerCallbacks(callbacks: {
    updateEvent: (eventId: string, updates: Partial<CalendarEvent>) => void;
    deleteEvent: (eventId: string) => void;
    addEvent: (event: CalendarEvent) => void;
  }) {
    this.updateEventCallback = callbacks.updateEvent;
    this.deleteEventCallback = callbacks.deleteEvent;
    this.addEventCallback = callbacks.addEvent;
  }

  // Unregister callbacks when calendar context unmounts
  unregisterCallbacks() {
    this.updateEventCallback = null;
    this.deleteEventCallback = null;
    this.addEventCallback = null;
  }

  // Public methods to update calendar events
  updateEvent(eventId: string, updates: Partial<CalendarEvent>) {
    if (this.updateEventCallback) {
      this.updateEventCallback(eventId, updates);
    }
  }

  deleteEvent(eventId: string) {
    if (this.deleteEventCallback) {
      this.deleteEventCallback(eventId);
    }
  }

  addEvent(event: CalendarEvent) {
    if (this.addEventCallback) {
      this.addEventCallback(event);
    }
  }

  // Helper methods for common exchange operations
  updateExchangeStatus(exchangeId: string, status: EEventStatus) {
    this.updateEvent(exchangeId, { status });
  }

  deleteExchange(exchangeId: string) {
    this.deleteEvent(exchangeId);
  }
}

export default CalendarEventManager.getInstance();

